module.exports = __webpack_public_path__ + "static/media/seo-lock-icon.24d1fb56.svg";